import { render, staticRenderFns } from "./IncidentsCalendar.vue?vue&type=template&id=d5afadec&"
import script from "./IncidentsCalendar.vue?vue&type=script&lang=js&"
export * from "./IncidentsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports